import { render, staticRenderFns } from "./ExChangeAccountOwner.vue?vue&type=template&id=4da1425f&scoped=true"
import script from "./ExChangeAccountOwner.vue?vue&type=script&lang=js"
export * from "./ExChangeAccountOwner.vue?vue&type=script&lang=js"
import style0 from "./ExChangeAccountOwner.vue?vue&type=style&index=0&id=4da1425f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1425f",
  null
  
)

export default component.exports